
import { defineComponent, PropType, onMounted, onUnmounted, ref } from 'vue';
import { Expert } from '@/types';
import IconExpert from "@/components/icons/IconExpert.vue";
import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

export default defineComponent({
  name: 'ExpertsSection',
  components: {
    IconExpert
  },
  props: {
    experts: {
      type: Array as PropType<Expert[]>,
      required: true,
      default: () => []
    }
  },
  setup() {
    const carouselInitialized = ref(false);
    let resizeTimeout: number | null = null;

    const destroyCarousel = () => {
      if (carouselInitialized.value) {
        //@ts-ignore
        $('.experts-carousel').trigger('destroy.owl.carousel');
        carouselInitialized.value = false;
      }
    };

    const initCarousel = () => {
      if (carouselInitialized.value) return;

      //@ts-ignore
      $('.experts-carousel').owlCarousel({
        loop: true,
        items: 4,
        nav: true,
        dots: false,
        smartSpeed: 200,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 3,
          },
          1200: {
            items: 4,
          }
        }
      });

      carouselInitialized.value = true;
    };

    const handleResize = () => {
      // Очищаем предыдущий таймер
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      
      // Устанавливаем новый таймер с debounce (300ms)
      resizeTimeout = setTimeout(() => {
        destroyCarousel();
        initCarousel();
      }, 300);
    };

    const getImageUrl = (pic: string) => {
      return `/pic/experts/${pic}`;
    };

    const handleImageError = (e: Event) => {
      const img = e.target as HTMLImageElement;
      img.src = '/pic/experts/default.png';
    };

    onMounted(() => {
      initCarousel();
      window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      destroyCarousel();
    });

    return {
      getImageUrl,
      handleImageError
    };
  }
});
